export type Config = {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId?: string;
};

export const config: Config = {
  apiKey: "AIzaSyDNCW5rX54VgmSO3c4LUmJYj8GmbizA8Lc",
  authDomain: "cloud-production-d4a64.firebaseapp.com",
  projectId: "cloud-production-d4a64",
  storageBucket: "cloud-production-d4a64.appspot.com",
  messagingSenderId: "133300833626",
  appId: "1:133300833626:web:ae07521f5e680d21dc3763",
};

export const vapidKey =
  "BChAFermToLGKL_vCX7-4KNOXWXC8a8CIQ4V1tepdUZK9ZCqXq9NsDyeEUJZPkTjbXWEQgnWVZotIj8YPkh7v00";
